import * as styles from './error.styles';
import { Card } from '../../atoms';

const ErrorPage = ({ children, background = '?' }) => {
  return (
    <div className={styles.root}>
      <div className={styles.background}>
        <span>{background}</span>
        <span>{background}</span>
      </div>
      <Card className={styles.card}>{children}</Card>
    </div>
  );
};

export default ErrorPage;
